/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetElevatedUsersResponseDto } from '../../models/get-elevated-users-response-dto';

export interface ElevatedUsers$Params {
  deleted?: boolean;
  pageSize?: number;
  page?: number;
}

export function elevatedUsers(http: HttpClient, rootUrl: string, params?: ElevatedUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<GetElevatedUsersResponseDto>> {
  const rb = new RequestBuilder(rootUrl, elevatedUsers.PATH, 'get');
  if (params) {
    rb.query('deleted', params.deleted, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('page', params.page, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetElevatedUsersResponseDto>;
    })
  );
}

elevatedUsers.PATH = '/api/v2/elevatedUsers';
